export const forms = {
  shared: {
    time: 'Time',
    note: 'Note',
    notePlaceholder: 'Optional, anything worth remembering',
    adjust: 'Adjust time or add a note',
  },

  diaper: {
    title: 'Diaper',
    editTitle: 'Edit diaper',
    quickHint: 'One tap saves it and you are done.',
    kindLabel: 'What was in the diaper?',
    wet: 'Wet',
    dirty: 'Dirty',
    both: 'Both',
  },

  weight: {
    title: 'Weight',
    editTitle: 'Edit weight',
    weightLabel: 'Weight',
    contextLabel: 'Where was this weight taken?',
    contexts: {
      birth: 'Birth weight',
      hospital: 'Hospital',
      office: 'Doctor visit',
      home: 'Home',
    },
    belowBirth: (pct: string) => `${pct}% below birth weight`,
    aboveBirth: (pct: string) => `${pct}% above birth weight`,
    checkInNote: 'Worth mentioning to the office; they will want to take a look.',
  },

  pump: {
    title: 'Pumping',
    editTitle: 'Edit pumping',
    amountsLabel: 'Amount pumped',
    durationLabel: 'Duration (minutes)',
    total: (amount: string) => `Session total: ${amount}`,
  },

  sleep: {
    title: 'Sleep',
    editTitle: 'Edit sleep',
    startLabel: 'Fell asleep',
    endLabel: 'Woke up',
    endOptionalHint: 'Leave blank if baby is still asleep.',
    fellAsleepNow: 'Baby fell asleep',
    wokeUpNow: 'Baby woke up',
    sleepingNow: 'Sleeping right now',
    duration: (d: string) => `Slept ${d}`,
    endBeforeStart: 'The wake-up time needs to be after the fall-asleep time.',
  },

  units: {
    lb: 'lb',
    oz: 'oz',
    g: 'g',
    ml: 'ml',
  },
};
